module.exports = __webpack_public_path__ + "static/img/sb@2x.9077068.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sb@2x.png
// module id = HjSR
// module chunks = 1